/**
 * Mi Boleta — decisión del CTA del detalle de una Flash Sale (C3).
 *
 * Pieza pura y sin React a propósito: el bucle que arregla —turno → detalle →
 * fila → turno → …— vivía en que el botón navegaba SIEMPRE a `/fila`, aun con el
 * turno ya en la URL. Aislar la decisión acá la hace verificable sin montar la
 * página, y deja la regla anti-bucle escrita en un solo lugar.
 *
 * La regla, en una frase: **con turno vigente el CTA lleva al checkout y NUNCA de
 * vuelta a `/fila`.** El permiso real de compra lo exige el checkout contra el
 * ticket admitido en `api-core`; esta decisión es sólo de ruteo del front.
 */
export interface FlashSaleCtaInput {
  /** Id de la venta, para componer el destino de la fila. */
  saleId: string;
  /** El fan ya tiene turno vigente (la URL trae `?turno=1`). */
  hasTurn: boolean;
  /** Stock restante de la venta (`quantityAvailable - quantitySold`, ≥ 0). */
  remaining: number;
}

export interface FlashSaleCta {
  /** Texto del botón. */
  label: string;
  /** Destino al hacer click. `null` = botón deshabilitado (agotado, sin turno). */
  to: string | null;
}

export function resolveFlashSaleCta({
  saleId,
  hasTurn,
  remaining,
}: FlashSaleCtaInput): FlashSaleCta {
  // Con turno: el fan ya pasó la fila. Va al checkout, JAMÁS de vuelta a `/fila`
  // —ese retorno era el bucle—. El stock no lo bloquea acá: si hay turno, la
  // admisión ya ocurrió y el checkout es quien valida contra el ticket.
  if (hasTurn) {
    return { label: 'Ir a pagar', to: '/checkout?mode=flash' };
  }

  // Sin turno y sin stock: agotado, sin destino.
  if (remaining <= 0) {
    return { label: 'Agotado', to: null };
  }

  // Sin turno, con stock: entra a la Fila Virtual.
  return { label: 'Comprar ahora', to: `/flash-sales/${saleId}/fila` };
}
